module.exports = __webpack_public_path__ + "assets/img/2-1-en.d3e0b399.png";